import { gsap } from "gsap";
import BezierEasing from 'bezier-easing';

import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import NoScroll from './NoScroll';
import InfiniteScroll from '../_app/cuchillo/scroll/InfiniteScroll';
import InfiniteScroll__Item from '../_app/cuchillo/scroll/InfiniteScroll__Item';
import { GetBy } from '../_app/cuchillo/core/Element';
import { CSS } from "../_app/cuchillo/utils/CSS";
import { Basics, isMobile } from "../_app/cuchillo/core/Basics";
import { Maths } from "../_app/cuchillo/utils/Maths";
import Header from "../layout/Header";
import Keyboard from "../_app/cuchillo/core/Keyboard";

export default class PagePlayer extends NoScroll {
  

  constructor() {
    super();

  }

  beforeShow() {
    ControllerPage.enable_ESC_Mode();
    Keyboard.mountPage(this.id);
  }

  afterShow() {
    Header.hideAlpha();
    super.afterShow();
  }

  beforeHide() {
    ControllerPage.enable_ESC_Mode(false);
    super.beforeHide();
  }

  afterHide() {
    super.afterHide();
    Header.showAlpha();
  }
}

ControllerPage._addPage('page-player', PagePlayer);